// extracted by mini-css-extract-plugin
export default {"main-header":"Header_main-header__kfwSs"};